<template>
  <div class="ranking">

    <NavigationBar>
      <template v-slot:left>
        <img v-on:click="goBack" class="back" src="../assets/icons/ic_16_back.svg">
      </template>
      <template v-slot:center>
        Rankings
      </template>
      <template v-slot:right>
      </template>
    </NavigationBar>
    
    <!-- Gesamtranking -->
    <div v-if="totalRanking.length">
      <h3>Gesamtranking</h3>
      <table class="ranking-table">
        <thead>
        <tr>
          <th>Pos</th>
          <th>User</th>
          <th>Punkte</th>
          <th>Punkte</th>
          <th>Question</th>
          <th>Korrektur</th>
          <th>Spieltagsiege</th>
          <th>Exakt</th>
          <th>Diff</th>
          <th>Tendenz</th>
          <th>0Pkt</th>
          <th>Anz</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in totalRanking" :key="row.user">
          <td>{{ row.position }}</td>
          <td>{{ row.user_name }}</td>
          <td>{{ row.points }}</td>
          <td>{{ row.points - row.question - row.correction }}</td>
          <td>{{ row.question }}</td>
          <td>{{ row.correction }}</td>
          <td>{{ row.matchdayWins }}</td>
          <td>{{ row.bet_exact }}</td>
          <td>{{ row.bet_goal_diff }}</td>
          <td>{{ row.bet_result }}</td>
          <td>{{ row.bet_no_points }}</td>
          <td>{{ row.betcount }}</td>
        </tr>
        </tbody>
      </table>
    </div>


    <!-- Spieltag-Auswahl -->
    <div class="form-group" style="margin-top: 50px;">
      <label for="matchdaySelect">Spieltag wählen:</label>
      <select id="matchdaySelect" v-model="selectedMatchday">
        <option v-for="md in matchdays" :key="md" :value="md">
          Spieltag {{ md }}
        </option>
      </select>
    </div>

    <!-- Spieltag Ranking -->
    <div v-if="selectedMatchday && matchdayRanking.length">
      <h3>Spieltag {{ selectedMatchday }}</h3>
      <table class="ranking-table">
        <thead>
        <tr>
          <th>Pos</th>
          <th>User</th>
          <th>Punkte</th>
          <th>Exakt</th>
          <th>Diff</th>
          <th>Tendenz</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in matchdayRanking" :key="row.user">
          <td>{{ row.position }}</td>
          <td>{{ row.user_name }}</td>
          <td>{{ row.points }}</td>
          <td>{{ row.bet_exact }}</td>
          <td>{{ row.bet_goal_diff }}</td>
          <td>{{ row.bet_result }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    
  </div>
</template>

<script>
import NavigationBar from '@/components/NavigationBar.vue'

export default {
  name: "Ranking",
  components: { NavigationBar },
  data() {
    return {
      worker: null,
      selectedMatchday: 1,
      rankings: { matchdays: {}, total: [], perUserMatch: {} }
    };
  },
  computed: {
    matchdays() {
      return Object.keys(this.rankings.matchdays).sort((a, b) => a - b);
    },
    matchdayRanking() {
      return this.rankings.matchdays[this.selectedMatchday] || [];
    },
    totalRanking() {
      return this.rankings.total || [];
    }
  },
  created() {
    const url = `${process.env.BASE_URL}js/RankingWorker.js`; // statt "/workers/..."
    this.worker = new Worker(url);
    this.worker.onmessage = (e) => {
      this.rankings = e.data;
      if (!this.selectedMatchday && this.matchdays.length) {
        this.selectedMatchday = this.matchdays[0];
      }
    };

    this.$store.dispatch('fetchSchedule', this.$store.state.leagueId).then(() => {
      this.$store.dispatch('fetchBetgameUsers', this.$store.state.betgameId).then(() => {
        this.$store.dispatch('fetchBets', null).then(() => {
          this.$store.dispatch('fetchQuestionRankings', this.$store.state.betgame.id).then(() => {
            this.$store.dispatch('fetchUserBetgamePoints', this.$store.state.betgame.id).then(() => {
              var bonus = []
              for (let i = 0; i < this.$store.state.userBetgamePoints.length; i++) {
                var ubp = this.$store.state.userBetgamePoints[i]
                ubp.type = 'correction'
                bonus.push(ubp)
              }
              for (let i = 0; i < this.$store.state.questionRankings.length; i++) {
                var ubp = this.$store.state.questionRankings[i]
                ubp.type = 'question'
                ubp.points = ubp.sum
                bonus.push(ubp)
              }
              const res = this.$store.state.matches
              const b = this.$store.state.bets
              const users = this.$store.state.betgameUsers
              this.worker.postMessage({ results: res, tips: b, bonus: bonus, users: users, 
                betgame: this.$store.state.betgame })
            })
          })
        })
      })
    })
  },
  methods: {
    goBack () {
      this.$router.push('/profile')
    }
  }
};
</script>

<style scoped>
.ranking {
  max-width: 800px;
  margin: 20px auto;
}
.ranking-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.ranking-table th,
.ranking-table td {
  border: 1px solid #ccc;
  padding: 6px 10px;
  text-align: center;
}
.ranking-table th {
  background: #f4f4f4;
}
.form-group {
  margin-bottom: 10px;
}
</style>
